// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"6ca04d29","307":"7a863746","653":"4f4f632f","708":"970af82d","941":"08e7e8b9"}[chunkId] + ".chunk.css";
};